import { render, staticRenderFns } from "./UploadSingleDocument.vue?vue&type=template&id=a6249e72&scoped=true"
import script from "./UploadSingleDocument.vue?vue&type=script&lang=js"
export * from "./UploadSingleDocument.vue?vue&type=script&lang=js"
import style0 from "./UploadSingleDocument.vue?vue&type=style&index=0&id=a6249e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6249e72",
  null
  
)

export default component.exports